import React, { useEffect, useState } from "react";
import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Card,
  Button,
  Form,
  Select,
  DatePicker,
  InputNumber,
  Spin,
  Row,
  Col,
} from "antd";
import { RollbackOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

import { getAPI, postAPI, displayMessage } from "../../../utils/common";
import { SUCCESS_MESSAGE, ERROR_MSG_TYPE } from "../../../constants/messages";
import { ALL_VENDOR, CREATE_LAUNDRY_PAYMENT } from "../../../constants/api";

const { Content } = Layout;

function PaymentAdd() {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(false);

  // Load vendors
  useEffect(() => {
    getAPI(ALL_VENDOR, (res) => {
      if (res.status) setVendors(res.data);
    });
  }, []);

  const submitData = (values) => {
    setLoading(true);

    const payload = {
      vendor_id: values.vendor_id,
      payment_date: dayjs(values.payment_date).format("YYYY-MM-DD"),
      amount: values.amount,
      mode: values.mode,
    };

    postAPI(
      CREATE_LAUNDRY_PAYMENT,
      payload,
      (res) => {
        setLoading(false);
        if (res.status === true) {
          displayMessage(SUCCESS_MESSAGE, res.message);
          navigate("/laundry/payment");
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to save payment");
      }
    );
  };

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Add Vendor Payment"
          extra={
            <Button onClick={() => navigate(-1)} type="primary" ghost>
              <RollbackOutlined />
            </Button>
          }
        >
          <Spin spinning={loading}>
            <Form form={form} layout="vertical" onFinish={submitData}>
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <Form.Item
                    name="vendor_id"
                    label="Vendor"
                    rules={[{ required: true }]}
                  >
                    <Select placeholder="Select Vendor">
                      {vendors.map((v) => (
                        <Select.Option key={v.id} value={v.id}>
                          {v.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item
                    name="payment_date"
                    label="Payment Date"
                    rules={[{ required: true }]}
                  >
                    <DatePicker />
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item
                    name="mode"
                    label="Payment Mode"
                    rules={[{ required: true }]}
                  >
                    <Select placeholder="Select Mode">
                      <Select.Option value="cash">Cash</Select.Option>
                      <Select.Option value="upi">UPI</Select.Option>
                      <Select.Option value="bank">Bank</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item
                    name="amount"
                    label="Amount"
                    rules={[{ required: true }]}
                  >
                    <InputNumber
                      min={1}
                      style={{ width: "100%" }}
                      placeholder="500"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    style={{ float: "right" }}
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default PaymentAdd;
